<div class="row">
    <div class="col-md-4 mx-auto">
        <div class="card">
            <div class="card-header">
                SignIn
            </div>
            <div class="card-body">
                <form (submit)="SignIn()">
                    <div class="form-group">
                        <input type="text" [(ngModel)]="user.email" name="email" class="form-control" placeholder="Email" required autofocus>
                    </div>
                    <div class="form-group">
                        <input type="password" [(ngModel)]="user.password" name="password" class="form-control" placeholder="Password" required autofocus>
                    </div>
                    <button type="submit" class="btn btn-primary btn-block">
                        SignUp
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>
